import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";

const id = "modal-add-welcome-video";
const form = "add-welcome-video";

const WelcomeVideo = ({ workflow }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <form
      action="/actions/getting-started/video"
      method="POST"
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="welcomeVideo" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("welcomeVideoModal.title")}
        className="getting-started-video narrow"
      >
        <div className="body">
          <VideoUpload
            form={form}
            video={workflow.options.welcomeVideo?.video}
          />
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            {t("welcomeVideoModal.submitButton")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default WelcomeVideo;
